import React, { Component, useState, useEffect, useRef } from 'react';
import { Button, Table, Input, Form, FormFeedback, FormGroup, FormText } from 'reactstrap';
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';
import GridExample from '../../tools/EditableTable';

const IndiSaltoRoom = (props) => {
    const dispatch = useDispatch()
    const selectAuthToken = state => state.apiKey
    const selectStore = state => state
    const authToken = useSelector(selectAuthToken);
    const reduxData = useSelector(selectStore);
    const [tableRerender, setTableRerender] = useState(1)
    const [roomSelect, setRoomSelect] = useState([])
    const [activeRoom, setActiveRoom] = useState("DEFAULT")
    const [saltoSelect, setSaltoSelect] = useState([])
    const [activeSalto, setActiveSalto] = useState("DEFAULT")
    const [tableData, setTableData] = useState([])
    const [deleteList, setDeleteList] = useState([])
    const [askedToDelete, setAskedToDelete] = useState(false)
    const [refreshInputList, setRefreshInputList] = useState(0)

    useEffect(() => {
        getFormData();
        getTableData()
    }, [])

    useEffect(() => {
        console.log("deleteList: ", deleteList )
    }, [deleteList])

    function updateCallback() {

    }

    function getFormData() {
        let bearerVAR = "Bearer " + authToken
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk
        }
        fetch('IndiSaltoRoomGetFormData', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => {
                setRoomSelect(responseJSON.room);
                setSaltoSelect(responseJSON.saltogroup);
            })
        
    }

    function getTableData() {
        let bearerVAR = "Bearer " + authToken
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            query:4
        }
        fetch('FindData', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => {
                setTableData(JSON.parse(responseJSON[0]))
                setAskedToDelete(false)
                setDeleteList([])
                setRefreshInputList(refreshInputList + 1)
            })
    }

    function submitForm() {
        let bearerVAR = "Bearer " + authToken
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            room: activeRoom,
            saltogroup: activeSalto
        }
        fetch('IndiSaltoRoomAddNew', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => getTableData())
    }

    function checkboxControl (pk) {
        if (deleteList.indexOf(pk) <= -1) {
            setDeleteList([...deleteList, pk])
            
        }
        else {
            let currList = deleteList
            let index = currList.indexOf(pk)
            currList.splice(index, 1);
            setDeleteList(currList)
            
        }
    }

    function deleteAll() {
        let bearerVAR = "Bearer " + authToken
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            targets: deleteList
        }
        fetch('IndiSaltoRoomDeleteAll', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => {
                getTableData()
                
            })
    }

    return (<div>
        <h3>Classroom</h3><br />
        <div className="halfOfParent">{roomSelect.length > 0 && <Form className="d-flex">
            <Input type="select" name="roomSelect" id="roomSelect" value={activeRoom} onChange={(e) => setActiveRoom(e.target.value)}>
                <option disabled value="DEFAULT">Select Room</option>
                {roomSelect.map(item => (
                    <option value={item.roomcode}>{item.roomname}</option>
                )) }
            </Input>
            <Input type="select" name="saltoSelect" id="saltoSelect" value={activeSalto} onChange={(e) => setActiveSalto(e.target.value)}>
                <option disabled value="DEFAULT">Select Salto Group</option>
                {saltoSelect.map(item => (
                    <option value={item}>{item}</option>
                )) }
            </Input>
            <Button onClick={() => submitForm() }>Go</Button>
        </Form>}</div>
        <br />
        <Table>
            <thead>
                <tr>
                    {/*<th>PK</th>*/}
                    <th>Building</th>
                    <th>Room</th>
                    <th>Salto Group</th>
                    <th>Created By</th>
                    <th>Created On</th>
                    <th>Delete this?</th>
                </tr>
            </thead>
            <tbody>
                {tableData.map(item => (
                    <tr>
                        {/*<td>{item.PK}</td>*/}
                        <td>{item.Building_Code}</td>
                        <td>{item.Room_ID}</td>
                        <td>{item.SaltoGroup}</td>
                        <td>{item.CreateBy}</td>
                        <td>{item.CreateDate}</td>
                        <td><Input key={refreshInputList} type="checkbox" id={"deleteThis_" + item.PK} name={"deleteThis_" + item.PK} isChecked={deleteList.indexOf(item.PK) > -1 ? true: false } onClick={() => checkboxControl(item.PK)} /></td>
                    </tr>
                )) }
            </tbody>
        </Table>
        <br />
        <div className="rightAlignCustom">{askedToDelete && <Button color="danger" onClick={() => deleteAll()}>Are you sure?</Button>}&ensp;<Button onClick={() => setAskedToDelete(true)}>Delete All Checked</Button></div>
        

    </div>)
}

export default IndiSaltoRoom;